import $ from 'jquery';

const allPartners = $(
    '.partners-block-ins-partners, .partners-block-other-partners'
);

for (let i = 0; i < allPartners.length; i++) {
    const currentPartner = allPartners.eq(i);
    const setPartnerWidth = () => {
        const bodyWidth = $('body').outerWidth();

        if (window.matchMedia('(max-width: 575.98px)').matches) {
            currentPartner.css('width', bodyWidth);
        } else {
            currentPartner.css('width', '');
        }
    };

    $(window).bind('resize', setPartnerWidth).trigger('resize');
}
